import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TicketSummaryPanelContainer = styled("div")(({ theme }) => ({
  position: "relative",
  height: "min-content",
  maxWidth: theme.space._1300,
  flexGrow: 1,
  borderRadius: "1rem",
  overflow: "hidden",
  background: theme.colors["neutral.900"],
  zIndex: 0
}));

export const TicketSummaryPanelContentContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  zIndex: 1
}));

export const TicketHolderContainer = styled("div")<{ allocationsAttendanceStyle?: boolean }>(({ theme, allocationsAttendanceStyle }) => ({
  display: "flex",
  height: allocationsAttendanceStyle ? "7.25rem" : theme.space._800,
  padding: `0 ${theme.space._500}`,
  alignItems: "center",
  gap: theme.space._200,
  alignSelf: "stretch",
  backgroundImage: `linear-gradient(to left, ${theme.colors["neutral.700"]} 55%, rgba(255,255,255,0) 0%)`,
  backgroundPosition: "top",
  backgroundSize: `${theme.space._350} ${theme.space._10}`,
  backgroundRepeat: "repeat-x",
  zIndex: 1,
  color: theme.colors["neutral.50"],
}));

export const TicketHolder = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.base,
  maxWidth: "11rem",
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const BadgeContainer = styled("div")(({ theme }) => ({
  marginLeft: "auto"
}));

export const GuestTicketContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderTop: `2px dashed ${theme.colors["neutral.700"]}`,
  borderRight: 'transparent',
  borderBottom: 'transparent',
  borderLeft: 'transparent',
  width: '100%',
  padding: '.7rem 1rem .7rem 1.2rem',
  justifyContent: "space-between"
}));

export const GuestTicketNames = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.base,
  marginLeft: '.5rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const GuestToggleButtonContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  backgroundColor: theme.colors["green.900"],
  padding: '.3rem',
  borderRadius: '2rem',
  marginLeft: '1rem',

}));

export const LeadBookerContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  padding: '1rem',
  borderBottom: `2px dashed ${theme.colors["neutral.700"]}`,
}));

export const LeadBookerName = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.base,
}));
export const LeadBookerNameIcon = styled(Typography)(({ theme }) => ({
  color: theme.colors["pink.500"],
  marginRight: '.5rem'
}));


export const TicketStateText = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.base,
}));

export const JustifyCenterContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
  zIndex: 1,
  paddingBottom: "3rem"
}));
